import { configureStore, combineReducers } from "@reduxjs/toolkit";
import { persistReducer, persistStore, FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session"; // Uses sessionStorage
// import storage from "redux-persist/lib/storage"; // Uncomment if you want to use localStorage

import authReducer from "./reducers/authSlice";
import appDataReducer from "./reducers/appDataSlice";

// --- Combine all reducers ---
const rootReducer = combineReducers({
  auth: authReducer,
  appData: appDataReducer,
});

// --- Persist configuration ---
const persistConfig = {
  key: "root",
  storage: storageSession, // Use sessionStorage; switch to `storage` for localStorage
  whitelist: ["auth"], // Specify which reducers to persist
};

// --- Create persisted reducer ---
const persistedRootReducer = persistReducer(persistConfig, rootReducer);

// --- Configure store ---
export const store = configureStore({
  reducer: persistedRootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }),
  devTools: process.env.NODE_ENV !== "production", // Enable Redux DevTools only in dev
});

// --- Persistor for Redux Persist ---
export const persistor = persistStore(store);
